class NotificationsWrapper extends HTMLElement {
  constructor() {
    super();
    this.newsletterOpen = false;
    this.notificationModal = this.querySelector(".notification-modal");
  }

  connectedCallback() {
    document.addEventListener("DOMContentLoaded", () => {
      if (this.#hasUnreadNotifications())
        this.classList.add("notifications-wrapper--has-unread");
    });

    this.#setEventListener();
  }

  #hasUnreadNotifications() {
    return this.querySelectorAll(".notification-popup--active").length > 0;
  }

  #updateModalHeight() {
    if (window.innerWidth > 750) {
      if (this.newsletterOpen) {
        this.notificationModal.style.height =
          this.querySelector(".notification__newsletter").offsetHeight + "px";
      } else {
        this.notificationModal.style.height =
          this.querySelector(".notification-modal__notifications")
            .offsetHeight + "px";
      }
    }
  }

  #openNewsletter() {
    this.#updateModalHeight();
    this.newsletterOpen = true;
    this.classList.add("notifications-wrapper--newsletter-open");
    this.#updateModalHeight();
  }

  #closeNewsletter() {
    this.newsletterOpen = false;
    this.classList.remove("notifications-wrapper--newsletter-open");
    this.#updateModalHeight();
  }

  #setEventListener() {
    this.querySelectorAll(".notification-popup--newsletter").forEach(
      (notification) => {
        notification.addEventListener("click", this.#openNewsletter.bind(this));
      }
    );

    this.querySelector(".notification__newsletter-close")?.addEventListener(
      "click",
      this.#closeNewsletter.bind(this)
    );

    this.querySelectorAll(".notification-popup").forEach((notification) => {
      notification.addEventListener("click", () => {
        setTimeout(() => {
          if (!this.#hasUnreadNotifications())
            this.classList.remove("notifications-wrapper--has-unread");
        }, 100);
      });
    });

    document.addEventListener("click", (e) => {
      const details = this.querySelector("details");

      if (
        !this.querySelector(".notification-modal")?.contains(e.target) &&
        !this.querySelector("details[open]")?.contains(e.target) &&
        details.attributes.getNamedItem("open")
      ) {
        this.#closeNewsletter();
        details.removeAttribute("open");
      }
    });
  }
}

customElements.define("notifications-wrapper", NotificationsWrapper);
